export const DEFAULT_PARTIAL_SAVE_DEBOUNCE_MS = 1500;

export type SavePartialResponseOption = boolean | { debounceMs?: number };

export function resolvePartialSaveDebounceMs(option?: SavePartialResponseOption): number {
  if (option === true || option === undefined || option === false) {
    return DEFAULT_PARTIAL_SAVE_DEBOUNCE_MS;
  }
  return option.debounceMs ?? DEFAULT_PARTIAL_SAVE_DEBOUNCE_MS;
}

export function isPartialSaveEnabled(option?: SavePartialResponseOption): boolean {
  return option === true || (typeof option === 'object' && option !== null);
}
